import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import useViewedDrugsStore from 'src/hooks/useViewedDrugsStore';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import { getAnalyticPreparedDrugList } from 'src/hooks/useAnalytics/useAnalytics.helpers';
import { ItemListName } from 'src/api/analytic.types';
import trns from './trns';
import DrugsCarouselContainer from '../TopDrugs/DrugsCarouselContainer';

interface Props {
  itemListName?: ItemListName;
}

const ViewedDrugsContainer: FC<Props> = ({
  itemListName = ItemListName.YouBrowsedItem
}) => {
  const { viewedDrugsList, isLoading, loadCount } = useViewedDrugsStore();

  const drugListWithAnalyticData = useMemo(() => {
    if (!itemListName) {
      return viewedDrugsList;
    }

    return getAnalyticPreparedDrugList({
      drugs: viewedDrugsList,
      itemListName
    });
  }, [viewedDrugsList, loadCount]);

  if (drugListWithAnalyticData?.length === 0) {
    return null;
  }

  return (
    <DrugsCarouselContainer
      drugsList={drugListWithAnalyticData}
      isLoading={isLoading}
      gtagPrefix={GTAGPrefix.watched}
      customLabel={
        <h2 className="uppercase text-astronautBlue fs-header4-bold text-center">
          <FormattedMessage {...trns.viewedDrugs} />
        </h2>
      }
    />
  );
};

export default ViewedDrugsContainer;
